import { Modal } from "react-bootstrap";
import { useState } from "react";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { sendSelectedMails } from "../../lib/data";
import { ToastContainer, toast } from 'react-toastify';

import loader from "../../images/gif/loader.gif";


function DeletePopUp({ showDeleteModal, onConfirm, setShowModal }) {
    const confirmDelete = () => {
        onConfirm();
        setShowModal(false)
    };

    const handleClose = () => {
        setShowModal(false);
    };
    return (
        <>
            <ToastContainer closeButton={false} />
            <Modal show={showDeleteModal} onHide={handleClose} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ textTransform: "capitalize" }}>Are you sure you want to delete?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="dashboard-content-detail_form">

                        <button type="submit" id="actionBtn"
                            onClick={() => confirmDelete()}>Delete</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default DeletePopUp;